import { Link } from "react-router-dom";
import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import { books } from "../content";
import { breadcrumbSchema } from "../lib/structuredData";

function BooksPage() {
  return (
    <section id="books">
      <Seo
        description={`Our books and manuscripts: ${books.map((book) => book.title).join("; ")}. XSS Engineering is completed and pending review.`}
        jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Books", path: "/books" }])}
        path="/books"
        title="Writing | Robert Doe"
      />
      <p className="eyebrow">Ideas taking shape</p>
      <SectionHeader title="Writing & manuscripts" />
      <p className="books-intro reveal">
        Our books and manuscripts connect security, systems, and the human side of computing.
      </p>
      <div className="books-list">
        {books.map((book) => (
          <article aria-labelledby={`${book.id}-title`} className="book-card reveal" key={book.id}>
            <div aria-hidden="true" className={`book-cover${book.subtitle ? " book-cover-with-subtitle" : ""}`}>
              <span className="book-cover-label">{book.coverStatus || "Work in progress"}</span>
              <span className="book-cover-symbol">{String(books.indexOf(book) + 1).padStart(2, "0")}</span>
              <span className="book-cover-title">{book.coverTitle || book.title}</span>
              {book.subtitle ? <span className="book-cover-subtitle">{book.subtitle}</span> : null}
              <span className="book-cover-author">[Authors Loading...]</span>
            </div>
            <div className="book-details">
              <span className="book-status">{book.status}</span>
              <h2 id={`${book.id}-title`}>{book.title}</h2>
              <p>{book.description}</p>
              {book.tags.length > 0 ? <div aria-label="Topics" className="project-tags">
                {book.tags.map((tag) => <span className="project-tag" key={tag}>{tag}</span>)}
              </div> : null}
              <p className="book-note">{book.note}</p>
              <Link className="btn-secondary" to="/contact">Let's talk about this book</Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BooksPage;
